import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import api, { apiErr } from "@/lib/api";
import { Emblem } from "@/components/Logo";

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const [status, setStatus] = useState("checking");
  const [msg, setMsg] = useState("");
  const token = params.get("token");

  useEffect(() => {
    if (!token) { setStatus("error"); setMsg("No verification token provided."); return; }
    api.get(`/auth/verify-email?token=${encodeURIComponent(token)}`)
      .then(({ data }) => { setStatus("ok"); setMsg(data.message); })
      .catch((e) => { setStatus("error"); setMsg(apiErr(e)); });
  }, [token]);

  return (
    <div className="min-h-screen bg-ink grain flex items-center justify-center p-6">
      <div className="matte-card p-12 text-center max-w-md w-full">
        <Emblem className="h-12 w-12 mx-auto mb-6" />
        {status === "checking" && <><Loader2 size={40} className="animate-spin text-gold mx-auto mb-4" /><h1 className="font-serif text-3xl">Verifying your email…</h1></>}
        {status === "ok" && <><CheckCircle2 size={44} className="text-green-400 mx-auto mb-4" /><h1 className="font-serif text-4xl gold-text">Email verified.</h1><p className="text-white/55 mt-3">{msg}</p><Link to="/dashboard" className="btn-gold inline-block mt-7 px-8 py-3.5 text-xs uppercase tracking-widest rounded-sm">Go to Command Center</Link></>}
        {status === "error" && <><XCircle size={44} className="text-red-400 mx-auto mb-4" /><h1 className="font-serif text-3xl">Verification failed</h1><p className="text-white/55 mt-3">{msg}</p><Link to="/login" className="btn-outline-gold inline-block mt-7 px-8 py-3.5 text-xs uppercase tracking-widest rounded-sm">Back to Login</Link></>}
      </div>
    </div>
  );
}
